/* eslint-disable no-console */

function set(key, value, ttl = null) {
  const data = {
    value,
    expires_at: (ttl !== null) ? (new Date().getTime() + (ttl * 1000)) / 1 : null,
  };

  try {
    localStorage.setItem(key.toString(), JSON.stringify(data));
  } catch (e) {
    console.error(e);
  }
}

function del(key) {
  try {
    localStorage.removeItem(key.toString());
  } catch (e) {
    console.error(e);
  }
}

function get(key, defaultValue) {
  try {
    const data = JSON.parse(localStorage.getItem(key.toString()));
    if (data !== null) {
      if (data.expires_at !== null && data.expires_at < new Date().getTime()) {
        localStorage.removeItem(key.toString());
      } else {
        return data.value;
      }
    }
  } catch (e) {
    console.error(e);
    del(key);
  }
  return defaultValue || null;
}

export default {
  set,
  get,
  del,
};



// WEBPACK FOOTER //
// ./src/helpers/localStorage.js